import { saveAs } from 'file-saver';
import _, { isArray, isEmpty, isString } from 'lodash';
import { toast } from 'react-toastify';
import goldBadge from '.././assets/img/badge/gold.jpg';
import ogBadge from '.././assets/img/badge/og.png';
import platinumBadge from '.././assets/img/badge/platinum.jpg';
import silverBadge from '.././assets/img/badge/silver.jpg';
import eBook from '../assets/docs/e-book-new.pdf';
import logo from '../assets/img/saw-logo.png';
import { baseUrl, paymentStatusTypes, redirect_URL, requestHeader } from '../config';
import { appraisalRoutes, consultantRouter, registrarRoutes, userRoutes } from '../routes';
import { createCloseContactUsLead, getMyCountryObj } from '../store/actions/auth.action';
import * as leadAction from '../store/actions/lead.action';
import * as types from '../store/actions/types';
import * as userAction from '../store/actions/user.action';
import { getMyProfile } from '../store/actions/user.action';
import store from '../store/store';
import { profile } from './types';

import acquisition from '.././assets/img/new-design/acquisition.png';
import always_transparent from '.././assets/img/new-design/always_transparent.png';
import appraisals from '.././assets/img/new-design/appraisals.png';
import brand_protection from '.././assets/img/new-design/brand_protection.png';
import budgeting from '.././assets/img/new-design/budgeting.png';
import contract_negotiation from '.././assets/img/new-design/contract_negotiation.png';
import extensive_experience from '.././assets/img/new-design/extensive_experience.png';
import intimate_service from '.././assets/img/new-design/intimate_service.png';
import market_research from '.././assets/img/new-design/market_research.png';
import proven_track_record from '.././assets/img/new-design/proven_track_record.png';
import strategy from '.././assets/img/new-design/strategy.png';
import transfer_registration from '.././assets/img/new-design/transfer_registration.png';

import acquire from '.././assets/img/new-design/acquire.png';
import budgeting_group from '.././assets/img/new-design/budgeting_group.png';
import contact from '.././assets/img/new-design/contact.png';

import CryptoJS from 'crypto-js';
import { createBrowserHistory } from 'history';
import { getMyPaymentByLeadId } from 'store/actions/payment.action';
import {cancelPendingAppraisalRequests} from '../appraisal/appraisalRequestSession';
import errorMessages from './errorMessages';
let loadedDomain = '';
const legacyRecentSearchedDomainsKey = 'recentSearchedDomains';
export const history: any = createBrowserHistory();
export const docIds = {
  domainBudget: 'domain-budget',
  appraisalContactUs: 'appraisal-contact-us-form',
  domainEnquiryForm: 'Make An Inquiry', // "domain-enquiry",
  requiredFieldPopup: 'Required Field Popup', // "domain-enquiry",
  makeAndInquiryForm: 'Make An Inquiry',
  contactUs: 'contact-us',
};
export const customMenus = {
  oneTabLogin: 'One tab login',
};
export const getCustomMonth = (month: number) => {
  return new Date(new Date().setMonth(new Date().getMonth() + month));
};
export const interestToolTip = {
  sell: 'You are a person or company looking to sell a domain or a small number of domains.',
  buy: 'You are a person or company looking to purchase a single domain or a small number of domains.',
  investor: 'You buy and sell domains quite regularly or you are looking for portfolio representation.',
};
export const CheckAccess = (accessType: string) => {
  let myProfile = store.getState().userReducer.myProfile;
  if (!isEmpty(myProfile && myProfile.userDetail)) {
    return myProfile.userDetail[accessType];
  } else {
    return false;
  }
};
export const showBuyButton = () => {
  return !isUserLoggedIn() || (isUserLoggedIn() && checkUserInterested(userInterested.buy));
};

export const showSellButton = () => {
  return !isUserLoggedIn() || (isUserLoggedIn() && checkUserInterested(userInterested.sell));
};
export const splitName = (name: string) => {
  if (name) return { firstName: name.split(' ')[0], lastName: name.split(' ')[1] };
  return { firstName: name, lastName: name };
};
export const appraisalType = {
  og: 'OG Domains',
  platinum: 'Platinum Buzz',
  gold: 'Gold Buzz',
  silver: 'Silver Buzz',
};
export const previousActionConfigs = {
  buyDomain: 'buyDomain',
  createAccount: 'createAccount',
  handleSubmit: 'handleSubmit',
};
export const queryParams = {
  leadUID: 'leadUID',
};
export const userInterested = { investor: 'Investor', buyAndSell: 'buy & sell', upgrade: 'Upgrade', buy: 'Buyer', sell: 'Seller', appraisal: 'Appraisal', newsLetter: 'News Letter' };
export const ellipseImages = {
  budgeting: 'budgeting',
  strategy: 'strategy',
  appraisals: 'appraisals',
  transfer_registration: 'transfer_registration',
  market_research: 'market_research',
  contract_negotiation: 'contract_negotiation',
  acquisition: 'acquisition',
  brand_protection: 'brand_protection',
  extensive_experience: 'extensive_experience',
  intimate_service: 'intimate_service',
  always_transparent: 'always_transparent',
  proven_track_record: 'Proven Track Record',
  budgeting_group: 'budgeting_group',
  acquire: 'acquire',
  contact: 'contact',
};

declare const window: any;

export const SawLogo = logo;
export const sawEBook = eBook;
let days = 60;
export const nextTwoMonth = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
let countryObj: { country_code?: any; countryName?: string } = {};

export const myCountryDetails = async () => {
  if (!countryObj || _.isEmpty(countryObj)) {
    countryObj = await Promise.resolve(getMyCountryObj());
  }
  store.dispatch({ type: types.LOCAL_COUNTRY_DETAIL, payload: countryObj });
  return countryObj;
};
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const getAgentName = (agent: { first_name?: string; last_name?: string; name?: string }) => {
  if (!_.isEmpty(agent)) {
    if (agent?.first_name && agent?.last_name) {
      return agent?.first_name + ' ' + agent?.last_name;
    } else {
      return agent?.name;
    }
  }
  return '';
};

export const updateUser = async (email: string, phone?: string, myProfile?: profile | undefined, name: string = '') => {
  name = name || myProfile?.name || '';

  let obj: { phone?: string; email?: string; name?: string } = {};
  if (myProfile) {
    if (myProfile.phone !== phone && phone && myProfile.UID) {
      obj.phone = phone;
    }
    if (myProfile.email !== email && email && myProfile.UID) {
      obj.email = email;
    }
    if (myProfile.name !== name && name && myProfile.UID) {
      obj.name = name;
    }
  }
  return new Promise(async (resolve, reject) => {
    if (isEmpty(obj)) {
      resolve(true);
    } else {
      // let confirmMessage="like to update this contact info in your profile "
      if (myProfile && myProfile.UID) {
        let res = await userAction.updateMyProfile(obj);
        if (res) {
          return resolve(true);
        } else {
          reject(false);
        }
      } else {
        reject(false);
      }
    }
  });
};
export const storeToken = async (res: string, showVerification = false) => {
  return await new Promise(async (resolve, reject) => {
    try {
      if (res) {
        let token = 'Bearer ' + res;
        cancelPendingAppraisalRequests();
        store.dispatch({type: types.RESET_APPRAISAL_SESSION, payload: undefined});
        setLocalStorageValue(localStorageKeyValue.token, token);
        requestHeader.headers.Authorization = token;
        removeLocalStorageValue(legacyRecentSearchedDomainsKey);
        let profileDetails = await getMyProfile();
        setLocalStorageValue(localStorageKeyValue.userEmail, profileDetails.email);
        resolve(profileDetails);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const loginSignUpSuccess = async (res: string, showVerification = false) => {
  return await new Promise(async (resolve, reject) => {
    try {
      if (res) {
        let profileDetails = await storeToken(res);
        buyNewDomain();
        resolve(profileDetails);
      }
    } catch (error) {
      reject(error);
    }
  });
};
const UIRoleTypes = { consultant: 'Broker', customer: 'User' };
export const getUIRoleType = (roleType: string) => {
  if (roleType === roles.consultant) return UIRoleTypes.consultant;
  if (roleType === roles.buyer) return UIRoleTypes.customer;
  return roleType;
};
export const isValidEmail = (email: string) => {
  let email_expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email && !email_expression.test(email);
};

export const checkValidEmailAddress = (email: string) => {
  let email_expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email && email_expression.test(email);
};
export const checkRoleById = (roleId: string) => {
  let roleList = store.getState().userReducer.roleList;
  return _.find(roleList || [], { UID: roleId })?.roleType || '';
};

export const isInValidPassword = (password: string) => {
  // eslint-disable-next-line no-useless-escape
  let password_expression = /(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/;
  return !password_expression.test(password);
};
export const checkDomainHasExtension = (domainName: string) => {
  return domainName.includes('.');
};
export const isValidDomainName = (domainName: string) => {
  // /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(domainName)
  // should have once character and extension and no special character
  // const isValid = /^[a-zA-Z0-9-]{1,61}(?:\.[a-zA-Z]{2,})+$/.test(domainName);
  // return /^[a-zA-Z0-9-]{1,61}(?:\.[a-zA-Z]{2,})+$/.test(domainName)
  return true;
};
export const isUserLoggedIn = () => {
  if (localStorage.getItem('saw-token')) return true;
  return false;
};
export const hasSpecialCharacter = (domainName: string) => {
  return /[^a-zA-Z.]/.test(domainName);
};
export const Logout = () => {
  // let userType = _.get(store.getState().userReducer, "myProfile.role.roleType", "")
  if (isUserLoggedIn()) {
    userAction.userLogoutAction();
  }
  cancelPendingAppraisalRequests();
  store.dispatch({type: types.RESET_APPRAISAL_SESSION, payload: undefined});
  removeAllStorageItems();

  requestHeader.headers.Authorization = '';
  // let routerObj = _.find(routes, {path: history.location.pathname});

  // if (routerObj?.isPrivateRoute) {
  // let appraisalRouter = checkAppraisalRouter();
  // if (appraisalRouter) {
  //   return true;
  // }
  store.dispatch({ type: types.GET_MY_PROFILE, payload: {} });
  // store.dispatch({type: types.GET_MY_LEADS, payload: []});
  history.goBack();

  // handleLandingPageRouter();
  // }
};
export const checkAppraisalRouter = () => {
  return _.find(appraisalRoutes, { path: history.location.pathname });
};
export const getCodeFromWindowURL = (url: string) => {
  const popupWindowURL = new URL(url);
  return popupWindowURL.searchParams.get('code');
};
export const handleLandingPageRouter = () => {
  let userRoles = _.get(store.getState().userReducer, 'myProfile.roles', '');
  let isRegistrar = false;
  if (userRoles && Array.isArray(userRoles)) {
    userRoles.forEach((item) => {
      if (item.role.roleType === 'Registrar') isRegistrar = true;
    });
  }
  history.push(isRegistrar ? '/login' : '/');
};

export const handleToast = (payload: { message: any; toastId?: string }, type?: '' | 'success' | 'error' | 'info' | 'warn') => {
  let { message = {}, toastId = '', result = { message: {} } } = { ...payload };
  type = type || 'error';
  message = isString(payload) ? payload : getMessageString(message, result) || 'Something went wrong';
  toastId = toastId || message;
  toast[type](message, {
    toastId,
  });
};
const getMessageString = (message: any, result: any) => {
  let msg = isString(message) ? message : isString(result) ? result : isString(result.message) ? result.message : isString(message.message) ? message.message : message;
  msg = isString(msg) ? msg : 'Something went wrong';
  return msg;
};

export const checkIsUserPage = () => {
  let roleType = roles.buyer;
  if (_.find(registrarRoutes, { path: history.location.pathname.toLowerCase() })) {
    roleType = roles.registrar;
  } else if (_.find(consultantRouter, { path: history.location.pathname.toLowerCase() })) {
    roleType = roles.consultant;
  }
  return roleType;
};
export const downloadEbook = (leadUID: string) => {
  return new Promise((resolve) => {
    leadAction
      .downloadEbook(leadUID)
      .then(() => {
        saveAs(baseUrl + '/assets/saw-e-book.pdf', 'example.pdf');
        resolve(true);
      })
      .catch((e) => {
        resolve(true);
      });
  });
};
// export const getLocalCountryCode = () => {
//   try {
//     myCountryDetails();
//     return (countryObj && countryObj.country_code) || 'US';
//     //countryCode || "US"//countryObj && countryObj.countryCode || "91"
//   } catch (error) {
//     return 'US';
//   }
// };

export const getUserImageURL = (image: string) => {
  if (!image) {
    return '';
  }
  if (image.includes('http')) {
    return image;
  } else {
    return baseUrl + '/' + image;
  }
};

export const getPublicRegistrarAvatarURL = (
  registrarUID?: string,
  image?: string,
) => {
  if (!image) return '';
  if (/^https?:\/\//i.test(image)) return image;
  if (!registrarUID) return '';

  return `${baseUrl}/public/registrars/${encodeURIComponent(
    registrarUID,
  )}/avatar`;
};

export const handleDomainName = (domainName: string) => {
  if (domainName) {
    return domainName.includes('.') ? domainName : domainName + '.com';
  }
  return domainName.replace(/\s/g, '');
};

export const handlePageLoader = (leading: boolean, loaderContent?: string) => {
  store.dispatch({ type: types.PAGE_LOADER, payload: leading, loaderContent });
};
const getStatusString = (str: string) => {
  if (str.includes('sold')) {
    return 'sold';
  }
  if (str.includes('refund')) {
    return 'refunded';
  }
  if (str.includes('cancel')) {
    return 'canceled';
  }
  return str;
};

export let getStatus = (status?: string) => {
  let statusObj = { color: 'text-success', icon: 'fas fa-chart-line', status: status };
  if (status) {
    status = getStatusString(status.toLocaleLowerCase());
    switch (status) {
      case 'pending':
        statusObj.icon = 'fas fa-credit-card';
        statusObj.color = 'text-danger';
        return statusObj;
      case 'canceled':
        statusObj.icon = 'far fa-times-circle';
        statusObj.color = 'text-danger';
        return statusObj;
      // case "in progress":
      case 'new':
        statusObj.color = 'text-success';
        statusObj.icon = ' fas fa-chart-line';
        return statusObj;
      case 'sold':
        statusObj.icon = 'far fa-handshake';
        statusObj.color = 'theme-color';
        statusObj.status = 'Completed';
        return statusObj;
      case 'refunded':
        statusObj.icon = ' fas fa-dollar-sign';
        statusObj.color = 'text-primary';
        return statusObj;
      default:
        statusObj.icon = ' fas fa-chart-line';
        statusObj.color = 'text-success';
        statusObj.status = 'In Progress';
        return statusObj;
    }
  } else {
    statusObj.color = 'text-success';
    statusObj.icon = 'fas fa-chart-line';
    statusObj.status = 'In Progress';
    return statusObj;
  }
};

export const isUserRole = () => {
  let isBuyer = false;
  if (isUserLoggedIn()) {
    let myProfile = store.getState().userReducer.myProfile;
    if (myProfile && myProfile.roles && Array.isArray(myProfile.roles)) {
      myProfile.roles.forEach((item) => {
        if (item.role.roleType === 'Buyer') isBuyer = true;
      });
    }
  }
  return isBuyer;
};
export const checkDashboardHeader = () => {
  if (getMyRole().includes(roles.buyer)) {
    return getUserInterestIn() === userInterested.buy;
  }
  return true;
};
export const checkUserInterestedBuy = () => {
  if (getMyRole().includes(roles.buyer)) {
    return getUserInterestIn() === userInterested.buy;
  }
  return true;
};

export const checkUserInterested = (interest: string) => {
  if (getMyRole().includes(roles.buyer)) {
    return getUserInterestIn() === interest;
  }
  return true;
};

export const checkUserInterestedInvestor = () => {
  if (getMyRole().includes(roles.buyer)) {
    return getUserInterestIn() === userInterested.investor;
  }
  return false;
};

export const checkUserRoleAccessDashboard = () => {
  if (getMyRole().includes(roles.seller) && getMyRole().length === 1) return true;
};

export const getMyRole = () => {
  const myRoles: string[] = [];
  const roleList = _.get(store.getState().userReducer, 'myProfile.roles', '');
  if (roleList && Array.isArray(roleList)) {
    roleList.forEach((item) => {
      if (item?.role?.roleType) myRoles.push(item.role.roleType);
    });
  }
  if (myRoles.length === 0) myRoles.push(roles.buyer);
  return myRoles;
};
export const checkRole = (roleType: string, roles?: []) => {
  const roleList = _.get(store.getState().userReducer, 'myProfile.roles', '');
  const myRoles: string[] = [];
  if (roleList && Array.isArray(roleList)) {
    roleList.forEach((item) => {
      if (item?.role?.roleType) myRoles.push(item.role.roleType);
    });
  }
  return _.includes(myRoles, roleType);
};
export const getMyDetails = () => {
  return store.getState().userReducer.myProfile;
};

export const roles = { admin: 'Admin', consultant: 'Consultant', registrar: 'Registrar', buyer: 'Buyer', seller: 'Seller' };

export const getCaptchaToken = async (actionName: string) => {
  return new Promise(async (resolve) => {
    return await window.grecaptcha.ready(async () => {
      let token = await window.grecaptcha.execute(process.env.REACT_APP_google_recaptcha, { action: actionName });
      // window.grecaptcha.execute.reset();
      resolve(token);
    });
  });
};

/** google recaptcha */
export const recaptchaLoaded = () => document.querySelector('script#g-captcha') !== null;

export const loadRecaptchaScript = () => {
  const script = document.createElement('script');
  script.id = 'g-captcha';
  script.src = 'https://www.google.com/recaptcha/api.js?render=' + process.env.REACT_APP_google_recaptcha;
  script.async = true;
  script.defer = true;
  document.body.append(script);
};

export const getEllipseImage = (img: string) => {
  let ellipseImg;
  switch (img) {
    case ellipseImages.intimate_service:
      ellipseImg = intimate_service;
      break;
    case ellipseImages.always_transparent:
      ellipseImg = always_transparent;
      break;
    case ellipseImages.proven_track_record:
      ellipseImg = proven_track_record;
      break;
    case ellipseImages.acquisition:
      ellipseImg = acquisition;
      break;
    case ellipseImages.brand_protection:
      ellipseImg = brand_protection;
      break;
    case ellipseImages.extensive_experience:
      ellipseImg = extensive_experience;
      break;
    case ellipseImages.appraisals:
      ellipseImg = appraisals;
      break;
    case ellipseImages.transfer_registration:
      ellipseImg = transfer_registration;
      break;
    case ellipseImages.market_research:
      ellipseImg = market_research;
      break;
    case ellipseImages.contract_negotiation:
      ellipseImg = contract_negotiation;
      break;
    case ellipseImages.budgeting:
      ellipseImg = budgeting;
      break;
    case ellipseImages.strategy:
      ellipseImg = strategy;
      break;
    case ellipseImages.budgeting_group:
      ellipseImg = budgeting_group;
      break;
    case ellipseImages.acquire:
      ellipseImg = acquire;
      break;
    case ellipseImages.contact:
      ellipseImg = contact;
      break;

    default:
      ellipseImg = strategy;
      break;
  }
  return ellipseImg;
};

export const getBadgeTypeImage = (appraisalTypes: { type: string; info: string }) => {
  let badgeImage;
  switch (appraisalTypes.type) {
    case appraisalType.og:
      badgeImage = ogBadge;
      break;
    case appraisalType.platinum:
      badgeImage = platinumBadge;
      break;
    case appraisalType.silver:
      badgeImage = silverBadge;
      break;
    case appraisalType.gold:
      badgeImage = goldBadge;
      break;
    default:
      badgeImage = silverBadge;
      break;
  }
  return badgeImage;
};

export const encryptData = (data: string) => {
  let encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(data), 'saw-cryptoJS-key-retKey=6LdWnpwd').toString();
  return encryptedValue ? encryptedValue.replace(/\//g, '_enqos') : data;
};
export const decryptData = (encryptValue: string) => {
  try {
    let decrypted = CryptoJS.AES.decrypt(encryptValue.replace(/_enqos/g, '/'), 'saw-cryptoJS-key-retKey=6LdWnpwd');
    let decryptedValue = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedValue ? JSON.parse(decryptedValue) : encryptValue;
  } catch (error) {
    console.log(error, '@@@');
    return encryptValue;
  }
};
export const checkIsLowBudget = async (payload: any) => {
  let budget = Number(payload.offerAmount);
  // need to ignore sending same domain notification again and again
  if (!budget || budget < 500) {
    delete payload.password;
    await createCloseContactUsLead(payload);
    store.dispatch({ type: types.LOW_BUDGET_WINDOW, payload: payload });
    return true;
  }
  return false;
};
export const buyNewDomain = (domain: string = getLocalStorageValue(localStorageKeyValue.domainName), offerAmount: string = getLocalStorageValue(localStorageKeyValue.offerAmount), type: string = userInterested.buy) => {
  if (domain) {
    setLocalStorageValue(localStorageKeyValue.domainName, domain);
    setLocalStorageValue(localStorageKeyValue.offerAmount, offerAmount.toString());
    setLocalStorageValue(localStorageKeyValue.interestIn, type);
    store.dispatch({ type: types.SET_DOMAIN_NAME, payload: domain });
    store.dispatch({ type: types.SET_DOMAIN_OFFER_AMOUNT, payload: offerAmount.toString() });
    navigateUserLogin(domain, offerAmount.toString());
  } else {
    loadMyDetail();
  }
};
export const ignoreLocalStorageOnRemoveAll = (value: string) => {
  if (value !== localStorageKeyValue.userEmail && value !== localStorageKeyValue.registrarDetail && value !== localStorageKeyValue.registrarUID) return true;
  return false;
};
export const removeAllStorageItems = () => {
  Object.keys(localStorageKeyValue).forEach((key) => {
    let value = localStorageKeyValue[key];
    if (ignoreLocalStorageOnRemoveAll(value)) removeLocalStorageValue(value);
  });
  removeLocalStorageValue(legacyRecentSearchedDomainsKey);
};
export const removeLocalStorageItems = () => {
  removeLocalStorageValue(localStorageKeyValue.domainName);
  removeLocalStorageValue(localStorageKeyValue.offerAmount);
  removeLocalStorageValue(localStorageKeyValue.interestIn);
  // removeLocalStorageValue(localStorageKeyValue.registrarUID);
};
export const getUserFistName = () => {
  return capitalizeFirstLetter(splitName(getMyDetails()?.name).firstName);
};
export const navigateUserLogin = (currentDomainName: string, offerAmount?: string) => {
  if (isUserRole()) {
    leadAction.getMyLeads().then((leads) => {
      let lead = isArray(leads) && leads[0];
      if (lead) {
        if (checkIsUserPaid(lead.payments)) {
          historyPush(historyPath.dashboard);
        } else {
          store.dispatch({ type: types.LEAD_DETAILS, payload: lead });
          history.push('/hire-consultant');
        }
        handlePageLoader(false);
      } else {
        createLead(currentDomainName, offerAmount);
      }
    });
  } else {
    if (!checkAppraisalRouter()) historyPush(historyPath.dashboard);
  }
};
export const checkIsUserPaid = (payment) => {
  if (payment && payment.status === 'succeeded') {
    return true;
  }
  return false;
};

export const scrollDoc = (elementId: string) => {
  const domainNameForm = document.getElementById(elementId);
  if (domainNameForm) {
    domainNameForm.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      // inline: 'center'
    });
    setTimeout(() => {
      domainNameForm.focus();
    }, 500);
  } else if (elementId === docIds.appraisalContactUs) {
    history.push('/contact-us');
  }
};
export const getMinute = (minutes: number) => {
  let sixtySeconds = 1000 * 60;
  return sixtySeconds * minutes;
};
export const createLead = async (dn: string | null = getLocalStorageValue(localStorageKeyValue.domainName), offerAmount: string = getLocalStorageValue(localStorageKeyValue.offerAmount), ignoreBudget = false) => {
  if (dn && loadedDomain !== dn) {
    loadedDomain = dn;
    if (dn) {
      removeLocalStorageItems();
      let payload: { domainName: string; offerAmount?: string; registrarUID?: string } = {
        domainName: checkDomainHasExtension(dn) ? dn : dn + '.com',
        offerAmount,
      };
      handlePageLoader(true);
      let response = await leadAction.createLeadAction(payload);
      loadedDomain = '';
      if (response) {
        if (response.status === 200) {
          let leadDetails = response['data'];
          store.dispatch({ type: types.LEAD_DETAILS, payload: leadDetails });
          store.dispatch({ type: types.SET_DOMAIN_NAME, payload: '' });
          store.dispatch({ type: types.SET_DOMAIN_OFFER_AMOUNT, payload: '' });
          history.push('/hire-consultant');
        } else {
          handleToast({ message: response });
        }
      }
      handlePageLoader(false);
      // } else {
      //   handlePageLoader(false);
      //   handleToast({message: errorMessages.continueServiceWithDomainName}, 'warn');
    }
  }
};
export const localStorageKeyValue = {
  token: 'saw-token',
  domainName: 'domainName',
  registrarUID: 'registrarUID',
  registrarDetail: 'registrarDetail',
  offerAmount: 'offerAmount',
  userEmail: 'userEmail',
  password: 'password',
  phone: 'phone',
  userUID: 'userUID',
  myProfile: 'myProfile',
  promoCode: 'promoCode',
  interestIn: 'interestIn',
  userInterestIn: 'userInterestIn',
  userName: 'userName',
};

export const removeLocalStorageValue = (key: string) => {
  localStorage.removeItem(key.toString());
};
export const setLocalStorageValue = (key: string, value: string) => {
  localStorage.setItem(key, value);
};
export const getLocalStorageValue = (localValue: string) => {
  return localStorage.getItem(localValue) || '';
};

export const getRegistrarDetailFromLocalStorage = () => {
  let registrarObj = getLocalStorageValue(localStorageKeyValue.registrarDetail);
  if (registrarObj) {
    let registrarDetail = JSON.parse(registrarObj);
    if (registrarDetail && !_.isEmpty(registrarDetail)) {
      return registrarDetail;
    }
  }
  return false;
};

export const domainSplit = (domainName: string) => {
  let methodName = 'domainSplit';
  try {
    let splitArray = domainName.split('.');
    splitArray.splice(0, 1);
    let domain = domainName.split('.')[0] || '';
    let tld = splitArray.join('.');
    return { domain, tld };
  } catch (error) {
    // eslint-disable-next-line no-throw-literal
    throw { message: error, methodName: methodName };
  }
};
export const availableExtensions = ['com', 'net', 'org', 'io', 'xyz', 'ca', 'co'];

export const checkIsAvailableExtension = (domainName: string) => {
  let { tld } = domainSplit(domainName);
  return _.find(availableExtensions, (availableTld) => availableTld.toLocaleLowerCase() === tld.toLocaleLowerCase());
};

export const generateIntegrationLink = async (UID: string = '') => {
  try {
    let myProfile = store.getState().userReducer.myProfile;
    let url = redirect_URL + `/registrar-message?registrarId=${UID || myProfile.UID}&domainName=`;
    navigator && navigator.clipboard.writeText(url);
    handleToast({ message: 'Link copied in clipboard' }, 'success');
  } catch (error) {
    console.log(error);
  }
};

export const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

export const createAccount = (actionType = types.SIGN_UP_WITH_DOMAIN, payload: string = previousActionConfigs.buyDomain) => {
  if (isUserLoggedIn()) {
    if (checkUserInterestedInvestor()) {
      handleToast({ message: errorMessages.investorAccessDenied });
      scrollDoc(docIds.domainEnquiryForm);
    } else {
      historyPush(historyPath.dashboard);
    }
  } else {
    store.dispatch({ type: types.PREVIOUS_ACTION, payload: payload });
    store.dispatch({ type: actionType, payload: true });
  }
};

export const closeWindows = () => {
  // make previous action is empty so that nothing will happen after close window else the window will persist
  store.dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: false });
  store.dispatch({ type: types.SHOW_UPGRADE_WINDOW, payload: false });
  store.dispatch({ type: types.EMAIL_VERIFICATION, payload: false });
};

export const closePopup = () => {
  store.dispatch({ type: types.PREVIOUS_ACTION, payload: '' });
  closeWindows();
};
export const checkUserInterestIn = () => {
  // let appraisalRouter = checkAppraisalRouter();
  // if (appraisalRouter)
  //     return userInterested.appraisal
  let userRouter = _.find(userRoutes, { path: history.location.pathname });
  if (userRouter) return userInterested.buy;
  return userInterested.buy;
};

export const getUserInterestIn = () => {
  let myProfile = getMyDetails();
  return myProfile.userInterested;
};
export const checkPaymentForLead = async (leadUID: string) => {
  await getMyPaymentByLeadId(leadUID).then((result) => {
    if (result && result.status === paymentStatusTypes.success) {
      return result;
    }
  });
  // let leads = await leadAction.getMyLeads();
  // if (leads && leads.length > 0) lead = leads[0] || {};
};
export const fetchCurrentLeadDetail = async () => {
  let lead;
  if (isUserLoggedIn()) {
    if (isUserRole()) {
      // const {myLeadList} = store.getState().leadReducer;
      // if (myLeadList?.length > 0) {
      //   lead = myLeadList[0] || {};
      // } else {
      let leads = await leadAction.getMyLeads();
      if (leads && leads.length > 0) lead = leads[0] || {};
      // }
    }
  }
  store.dispatch({ type: types.LEAD_DETAILS, payload: lead });
  return lead;
};
export const historyPath = {
  dashboard: '/dashboard',
};
export const historyPush = (path: string) => {
  if (path === historyPath.dashboard && checkUserInterestedInvestor()) {
    handleToast({ message: errorMessages.investorAccessDenied });
    scrollDoc(docIds.makeAndInquiryForm);
  } else {
    history.push(path);
  }
};
export const blockInvestor = () => {
  if (history?.location?.pathname === historyPath.dashboard && checkUserInterestedInvestor()) {
    handleToast({ message: errorMessages.investorAccessDenied });
    scrollDoc(docIds.makeAndInquiryForm);
  }
};
export const loadMyDetail = async (isEnquiry = false) => {
  if (isUserLoggedIn()) {
    if (!checkAppraisalRouter() || isEnquiry) {
      if (checkUserInterestedInvestor()) {
        handleToast({ message: errorMessages.investorAccessDenied });
        scrollDoc(docIds.makeAndInquiryForm);
      } else if (isUserRole()) {
        let lead = await fetchCurrentLeadDetail();
        if (lead && !_.isEmpty(lead)) {
          if (checkIsUserPaid(lead.payments) && lead?.isSurveyCompleted) {
            historyPush(historyPath.dashboard);
          } else {
            if (checkIsUserPaid(lead.payments)) {
              store.dispatch({ type: types.PREVIOUS_ACTION, payload: '' });
              historyPush('/agent-details-questions');
            } else {
              store.dispatch({ type: types.PREVIOUS_ACTION, payload: '' });
              historyPush('/hire-consultant');
            }
          }
        } else {
          historyPush(historyPath.dashboard);
        }
      } else {
        historyPush(historyPath.dashboard);
      }
    } else {
      // scrollDoc(docIds.domainEnquiryForm)
    }
  }
};

export const makeAnEnquiry = () => {
  if (isUserLoggedIn()) {
    loadMyDetail(true);
  } else {
    if (getRegistrarDetailFromLocalStorage()) {
      history.push('/registrar-landing-page');
    } else {
      store.dispatch({ type: types.PREVIOUS_ACTION, payload: previousActionConfigs.createAccount });
      store.dispatch({ type: types.SIGN_UP_WITH_DOMAIN, payload: true });
      store.dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
    }
  }
};
export const routeIn = (except) => {
  return window.location.pathname.includes(except);
};
export const queryHandler = (query) => {
  let email = query.get('email');
  let showLogin = query.get('showLogin');

  // let password = query.get('password')
  if (email && !isUserLoggedIn()) {
    email = decryptData(email);
    if (checkValidEmailAddress(email) && !routeIn('unsubscribe') && !routeIn('hire-consultant')) {
      setLocalStorageValue(localStorageKeyValue.userEmail, email);
      store.dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
    }
  }
  if (showLogin) {
    store.dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
  }
  // if (localStorageKeyValue.password)
  //     setLocalStorageValue(localStorageKeyValue.password, password)
  setTimeout(() => {
    // history.replace({
    //     search: ""
    // })
  }, getMinute(1));
};

export const updateRegistrarDetail = (registrarDetail: any = '') => {
  if (registrarDetail) {
    setLocalStorageValue(localStorageKeyValue.registrarDetail, registrarDetail ? JSON.stringify(registrarDetail) : '');
    store.dispatch({ type: types.REGISTRAR_DETAIL, payload: registrarDetail });
  } else {
    store.dispatch({ type: types.REGISTRAR_DETAIL, payload: {} });
    removeLocalStorageValue(localStorageKeyValue.registrarDetail);
  }
};
export const getQueryValue = (name: string) => {
  const query = new URLSearchParams(history.location.search);
  return query.get(name);
};

export const checkShowPromoCode = (payload: { userInterested: string; registrarUID: string }) => {
  return !payload.registrarUID && payload.userInterested === userInterested.buy;
};

export const loadBasicAPIs = () => {
  // getMyAppraisalCount()
};

export const focusInput = (id: string) => {
  let doc = document.getElementById(id);
  if (doc) doc?.focus();
};
